/* global Forms */

import ApplicationController from './application_controller'

class FormsController extends ApplicationController {
  connect () {
    Forms.initForm()
  }
}

export default FormsController
